import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { useTheme } from "@mui/material/styles";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import Typography from "@mui/material/Typography";

const MuiDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export const DeleteDialog = ({
  row_id,
  label,
  deleteDialog,
  setDeleteDialog,
  handleDeleteClick,
}) => {
  const theme = useTheme();

  const handleContinueBtn = () => {
    setTimeout(() => {
      Array.isArray(row_id) ? handleDeleteClick(row_id[0], row_id[1]) : handleDeleteClick(row_id);
    }, 1000);
  };

  return (
    <MuiDialog
      onClose={() => setDeleteDialog(false)}
      aria-labelledby='customized-dialog-title'
      open={deleteDialog}
    >
      <DialogContent
        dividers
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "0px 20px !important",
          maxWidth: "500px",
          height: "260px",
        }}
      >
        <DeleteForeverOutlinedIcon
          sx={{
            fontSize: {
              xs: "3rem",  // small screens
              sm: "4rem",  // tablets
              md: "5rem",  // desktops
            },
            color: theme.palette.error.main,
          }}
        />

        <Typography
          sx={{
            padding: "0px 10px",
            margin: "30px 0px 0px 0px",
            fontWeight: "bold",
            fontSize: "1.1rem",
          }}
          variant='body1'
        >
          Are you sure you want to delete this {`${label}`}?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ padding: "0px", margin: "10px" }}>
        <Button
          autoFocus
          onClick={() => setDeleteDialog(false)}
          sx={{
            textTransform: "none",
            fontFamily: "Poppins, sans-serif",
            color: theme.palette.text.primary,
            height: "40px",
            borderRadius: "10px",
            padding: "10px",
            width: "5vw",
          }}
        >
          Cancel
        </Button>
        <Button
          btnVariant='contained'
          autoFocus
          onClick={handleContinueBtn}
          sx={{
            textTransform: "none",
            fontFamily: "Poppins, sans-serif",
            color: theme.palette.text.buttonhover,
            backgroundColor: theme.palette.button.main,
            height: "40px",
            "&:hover": {
              backgroundColor: theme.palette.buttonhover.main,
            },
            borderRadius: "10px",
            marginLeft: "20px",
            marginRight: "5px",
            padding: "20px",
            width: "5vw",
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </MuiDialog>
  );
};
